'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PromizeOption = function (_React$Component) {
    _inherits(PromizeOption, _React$Component);

    function PromizeOption() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, PromizeOption);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PromizeOption.__proto__ || Object.getPrototypeOf(PromizeOption)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            'showCopyPopup': false
        }, _this.pzCheckValidColorCode = function (colorCode) {
            return (/^#[0-9A-F]{6}$/i.test(colorCode) || /^#([0-9A-F]{3}){1,2}$/i.test(colorCode)
            );
        }, _this.makeMouseOutFn = function (elem) {
            var list = _this.traverseChildren(elem);
            return function onMouseOut(event) {
                var e = event.toElement || event.relatedTarget;
                if (!!~list.indexOf(e)) {
                    return;
                }
                //alert('MouseOut');
                // handle mouse event here!
            };
        }, _this.traverseChildren = function (elem) {
            var children = [];
            var q = [];
            q.push(elem);
            while (q.length > 0) {
                var elem = q.pop();
                children.push(elem);
                pushAll(elem.children);
            }
            function pushAll(elemArray) {
                for (var i = 0; i < elemArray.length; i++) {
                    q.push(elemArray[i]);
                }
            }
            return children;
        }, _this.pzRemoveImageFromCanvas = function (partNames, imageIdx) {
            var sourceOrigin = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '3d-customization-normal-repeat';
            var removeObjName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";

            var promizeThreeDObj = _this.props.promizeThreeDObj;
            var ImagePartData = {};

            partNames && Object.values(partNames).map(function (partName, idx) {
                var uploadedImageData = {};
                uploadedImageData['removeImage'] = [];
                if (removeObjName) {
                    uploadedImageData['removeImage'].push(removeObjName);
                } else {
                    uploadedImageData['removeImage'].push(partName + '_' + imageIdx);
                }

                ImagePartData[partName] = {
                    repeatSettings: {
                        spacing: 0,
                        groupSpacing: 0,
                        objectSpacing: {}
                    },
                    uploadData: uploadedImageData
                };
                var data3_8 = {
                    name: 'tag_component',
                    component: {
                        name: _this.props.pzBaseType ? _this.props.pzBaseType : '3/4',
                        component: {
                            name: 'tag',
                            customizationData: {
                                uploadData: [{}],
                                repeatData: {
                                    '3d-customization-normal-repeat': ImagePartData
                                }

                            }
                        }
                    }
                };
                promizeThreeDObj.updateComponent(data3_8);
            });
        }, _this.pzActiveOptionHoverHandler = function (optionText, event) {

            /*var list = this.traverseChildren(event);
            //return function onMouseOut(event) {
                var e = event.toElement || event.relatedTarget;
                if (!!~list.indexOf(e)) {
                    return false;
                }
               // alert('MouseOut');
                // handle mouse event here!
            //};*/

            var pzBoundRect = event.target.getBoundingClientRect();
            var OptionHover = {
                'text': optionText,
                'top': pzBoundRect.top + pzBoundRect.height, //event.clientY - event.target.offsetTop,
                'left': pzBoundRect.left + pzBoundRect.width / 2 //event.clientX - event.target.offsetLeft,
            };
            _this.props.HomeComponent.setState({ pzActiveOptionHover: OptionHover });
        }, _this.pzSetActiveOptionHandler = function (tabId, tabAttrId, attrValueId, pzOptionAttrValue, e) {
            // debugger;
            var _this$props = _this.props,
                pzActiveOptions = _this$props.pzActiveOptions,
                pzQuantity = _this$props.pzQuantity,
                pzBasePrice = _this$props.pzBasePrice,
                pzCustomizer = _this$props.pzCustomizer,
                pzCanvas = _this$props.pzCanvas,
                pzCanvasObject = _this$props.pzCanvasObject,
                pzPopupBackgroundAttr = _this$props.pzPopupBackgroundAttr;

            var pzProductPrice = _this.props.pzProductPrice;
            var pzPrice = pzProductPrice;
            if (pzActiveOptions[tabId] == undefined) {
                pzActiveOptions[tabId] = [];
            }
            var oldPrice = pzActiveOptions[tabId].length > 0 ? pzCustomizer.attributeOptions[pzActiveOptions[tabId][0]][pzActiveOptions[tabId][1]].promize_attribute_value.option_price : 0;
            if (oldPrice) {
                if (pzOptionAttrValue.option_price) {
                    pzPrice = parseFloat(pzPrice) - parseFloat(oldPrice * pzQuantity);
                    pzPrice = parseFloat(pzPrice) + parseFloat(pzOptionAttrValue.option_price * pzQuantity);
                } else {
                    pzPrice = parseFloat(pzPrice) - parseFloat(oldPrice * pzQuantity);
                }
            } else if (pzOptionAttrValue && pzOptionAttrValue.option_price) {
                pzPrice = parseFloat(pzPrice) + parseFloat(pzOptionAttrValue.option_price * pzQuantity);
            }

            var subTabs = pzCustomizer.subtabs[tabId] ? pzCustomizer.subtabs[tabId] : {};
            if (Object.keys(subTabs).length > 0 && Object.keys(pzActiveOptions).length > 0) {
                Object.keys(pzActiveOptions).map(function (option) {
                    var activeObj = subTabs[option];
                    /* let canvasObj = pzCanvas.getItemByField('tabId', parseInt(option));
                    if (activeObj && canvasObj) {
                        pzRemoveObjectFromCanvas(pzCanvas, canvasObj)
                        delete pzCanvasObject[pzCurrentView][canvasObj.name]
                        delete pzActiveOptions[option]
                    } */
                });
            }

            var findIdxSilkScreen = -1,
                findIdxDyesub = -1;
            var pzPopupAppliedData = _this.props.pzPopupAppliedData;
            /*  if ((pzOptionAttrValue.option_code.includes('silkscreen') &&
                    this.props.HomeComponent.pzCheckSameMaterialType('dyesub', tabId)) ||
                    Object.keys(pzPopupAppliedData).length > 0) { */
            if (e != undefined && (pzOptionAttrValue.option_code.includes('silkscreen') || pzOptionAttrValue.option_code.includes('dyesub') && !_this.props.pzColorIconClicked)) {
                var currActionOptions = pzActiveOptions[tabId];
                if (pzOptionAttrValue.option_code.includes('dyesub')) {
                    findIdxSilkScreen = currActionOptions.findIndex(function (element) {
                        return typeof element === "string" && element.indexOf('silkscreen') !== -1;
                    });

                    if (findIdxSilkScreen > -1) {
                        var textPartData = {};
                        Object.keys(pzCanvasObject).map(function (objKey, objIdx) {

                            if (objKey.includes('text')) {
                                pzCanvasObject[objKey].fill = "#000000";

                                var partNames = pzCanvasObject[objKey].partNames;
                                var _tabAttrId = pzCanvasObject[objKey].tabAttrId;

                                textPartData[partNames[0]] = {
                                    textData: {
                                        addText: _defineProperty({}, _tabAttrId, {
                                            properties: {
                                                fill: '#000000'
                                            }
                                        })
                                    }

                                    //console.log("pzCanvasObject ", pzCanvasObject)

                                };
                            }
                        });
                        var data3_8 = {
                            name: 'tag_component',
                            component: {
                                name: _this.props.pzBaseType ? _this.props.pzBaseType : '3/4',
                                component: {
                                    name: 'tag',
                                    customizationData: {
                                        repeatData: {
                                            '3d-customization-normal-repeat': textPartData
                                        }
                                    }
                                }
                            }
                        };
                        _this.props.promizeThreeDObj.updateComponent(data3_8);

                        //if (confirm("Do you want to switch the material from Dyesub to silkscreen? If yes, your current design will be removed.")) {

                        pzActiveOptions[tabId][0] = tabAttrId;
                        pzActiveOptions[tabId][1] = attrValueId;
                        pzActiveOptions[tabId][2] = pzOptionAttrValue.option_code;

                        // this.props.HomeComponent.pzPopupRemove2DImageFromCanvasByMaterialChange();

                        _this.props.HomeComponent.setState({ pzActiveOptions: pzActiveOptions, pzProductPrice: pzPrice, pzCanvasObject: pzCanvasObject, pzPopupAppliedData: pzPopupAppliedData }, function () {
                            //console.log("pzPopupAppliedData ", this.props.pzPopupAppliedData)
                            _this.props.HomeComponent.pzApplyRules();
                        });
                    }
                }
                if (pzOptionAttrValue.option_code.includes('silkscreen')) {

                    findIdxDyesub = currActionOptions.findIndex(function (element) {
                        return typeof element === "string" && element.indexOf('dyesub') !== -1;
                    });
                    //console.log("findIdxDyesub ", findIdxDyesub)
                    if (findIdxDyesub > -1) {
                        if (pzPopupBackgroundAttr.tabId) {
                            delete pzActiveOptions[pzPopupBackgroundAttr.tabId];
                        }

                        var _textPartData = {};

                        Object.keys(pzCanvasObject).map(function (objKey, objIdx) {
                            if (objKey.includes('background')) {
                                delete pzCanvasObject[objKey];
                            }

                            if (objKey.includes('text')) {
                                pzCanvasObject[objKey].fill = "#FFFFFF";

                                var partNames = pzCanvasObject[objKey].partNames;
                                var _tabAttrId2 = pzCanvasObject[objKey].tabAttrId;

                                _textPartData[partNames[0]] = {
                                    textData: {
                                        addText: _defineProperty({}, _tabAttrId2, {
                                            properties: {
                                                fill: '#FFFFFF'
                                            }
                                        })
                                    }

                                    //console.log("pzCanvasObject ", pzCanvasObject)

                                };
                            }
                        });
                        var _data3_ = {
                            name: 'tag_component',
                            component: {
                                name: _this.props.pzBaseType ? _this.props.pzBaseType : '3/4',
                                component: {
                                    name: 'tag',
                                    customizationData: {
                                        repeatData: {
                                            '3d-customization-normal-repeat': _textPartData
                                        }
                                    }
                                }
                            }
                        };
                        _this.props.promizeThreeDObj.updateComponent(_data3_);
                        pzPopupAppliedData = {};
                        _this.props.promizeThreeDObj.cleanUp(['2d-customization-popup-repeat', '4d-customization-texture-repeat']);

                        //if (confirm("Do you want to switch the material from Dyesub to silkscreen? If yes, your current design will be removed.")) {

                        pzActiveOptions[tabId][0] = tabAttrId;
                        pzActiveOptions[tabId][1] = attrValueId;
                        pzActiveOptions[tabId][2] = pzOptionAttrValue.option_code;

                        // this.props.HomeComponent.pzPopupRemove2DImageFromCanvasByMaterialChange();

                        _this.props.HomeComponent.setState({ pzActiveOptions: pzActiveOptions, pzProductPrice: pzPrice, pzCanvasObject: pzCanvasObject, pzPopupAppliedData: pzPopupAppliedData }, function () {
                            //console.log("pzPopupAppliedData ", this.props.pzPopupAppliedData)
                            _this.props.HomeComponent.pzApplyRules();
                        });
                    }
                }
            }

            /*    if ((pzOptionAttrValue.option_code.includes('silkscreen') &&
                   this.props.HomeComponent.pzCheckSameMaterialType('dyesub', tabId)) //&&
                   // Object.keys(pzPopupAppliedData).length > 0
               )  */
            if (findIdxSilkScreen == -1 && findIdxDyesub == -1) {
                pzActiveOptions[tabId][0] = tabAttrId;
                pzActiveOptions[tabId][1] = attrValueId;
                pzActiveOptions[tabId][2] = pzOptionAttrValue.option_code;

                var checkboxState = _this.state.showCopyPopup;
                var _this$props2 = _this.props,
                    pzActiveImages = _this$props2.pzActiveImages,
                    pzShowCopy = _this$props2.pzShowCopy,
                    pzIsCopyRepeatObjects = _this$props2.pzIsCopyRepeatObjects,
                    pzRepeatObjects = _this$props2.pzRepeatObjects,
                    pzCopyObjectsKeys = _this$props2.pzCopyObjectsKeys,
                    pzCopyRepeatObjects = _this$props2.pzCopyRepeatObjects,
                    pzCopyOuterObjKeys = _this$props2.pzCopyOuterObjKeys,
                    pzCopyInnerObjKeys = _this$props2.pzCopyInnerObjKeys,
                    pzCopyArraykeys = _this$props2.pzCopyArraykeys,
                    pzCopyOuterRepeatObjects = _this$props2.pzCopyOuterRepeatObjects;

                var apply2dObjects = false;
                if (pzOptionAttrValue.userEvent && pzOptionAttrValue.attribute_code == "copy_text_logo") {

                    //if (confirm("Do you want to duplicate the outer text and logo?")) {
                    pzIsCopyRepeatObjects = true;

                    var pzCurrInnerRepeatObjects = [].concat(_toConsumableArray(pzCopyObjectsKeys));

                    var removeInnerDatafromCanvas = function removeInnerDatafromCanvas(a, b) {
                        return b.filter(function (i) {
                            if (a.indexOf(i) === -1) {
                                var currData = pzCanvasObject[i];
                                //console.log("currData ", currData)
                                //this.pzRemoveImageFromCanvas(currData.partNames, currData.imageIndex)
                                _this.pzRemoveImageFromCanvas(currData.partNames, currData.imageIndex, '3d-customization-normal-repeat', currData.name);

                                delete pzCanvasObject[i];

                                if (_this.props.pzActiveImages[currData.tabAttrValueId]) {
                                    delete _this.props.pzActiveImages[currData.tabAttrValueId][currData.imageIndex];
                                }
                            }
                        });
                    };

                    removeInnerDatafromCanvas(pzCopyOuterRepeatObjects, pzCurrInnerRepeatObjects);

                    if (pzCopyOuterRepeatObjects.length > 0) {

                        pzCopyObjectsKeys = [];
                        pzCopyObjectsKeys = [].concat(_toConsumableArray(pzCopyOuterRepeatObjects));

                        pzIsCopyRepeatObjects = true;
                        pzShowCopy = true;

                        var objectIndex = 0; var textIndex = -1,
                            imageIndex = -1;

                        //Object.keys(pzRepeatObjects).length > 0 && Object.keys(pzRepeatObjects).map((objName, index) => {
                        pzCopyOuterRepeatObjects.length > 0 && pzCopyOuterRepeatObjects.map(function (objName, index) {

                            var name = '';
                            var tabAttributeId = 0;
                            if (objName.includes('text')) {

                                if (objName.includes(pzCopyOuterObjKeys[0])) {
                                    if (pzCopyInnerObjKeys[0].includes('text')) {
                                        name = objName.replace(pzCopyOuterObjKeys[0], pzCopyInnerObjKeys[0]);
                                        tabAttributeId = pzCopyInnerObjKeys[0].split('_')[1];
                                    } else if (pzCopyInnerObjKeys[1].includes('text')) {
                                        name = objName.replace(pzCopyOuterObjKeys[0], pzCopyInnerObjKeys[1]);
                                        tabAttributeId = pzCopyInnerObjKeys[1].split('_')[1];
                                    }
                                } else if (objName.includes(pzCopyOuterObjKeys[1])) {
                                    if (pzCopyInnerObjKeys[0].includes('text')) {
                                        name = objName.replace(pzCopyOuterObjKeys[1], pzCopyInnerObjKeys[0]);
                                        tabAttributeId = pzCopyInnerObjKeys[0].split('_')[1];
                                    } else if (pzCopyInnerObjKeys[1].includes('text')) {
                                        name = objName.replace(pzCopyOuterObjKeys[1], pzCopyInnerObjKeys[1]);
                                        tabAttributeId = pzCopyInnerObjKeys[1].split('_')[1];
                                    }
                                }
                            } else if (objName.includes('image')) {

                                if (objName.includes(pzCopyOuterObjKeys[0])) {
                                    if (pzCopyInnerObjKeys[0].includes('image')) {
                                        name = objName.replace(pzCopyOuterObjKeys[0], pzCopyInnerObjKeys[0]);
                                        tabAttributeId = pzCopyInnerObjKeys[0].split('_')[1];
                                    } else if (pzCopyInnerObjKeys[1].includes('image')) {
                                        name = objName.replace(pzCopyOuterObjKeys[0], pzCopyInnerObjKeys[1]);
                                        tabAttributeId = pzCopyInnerObjKeys[1].split('_')[1];
                                    }
                                } else if (objName.includes(pzCopyOuterObjKeys[1])) {
                                    //name = objName.replace(pzCopyOuterObjKeys[1], pzCopyInnerObjKeys[1])

                                    if (pzCopyInnerObjKeys[0].includes('image')) {
                                        name = objName.replace(pzCopyOuterObjKeys[1], pzCopyInnerObjKeys[0]);
                                        tabAttributeId = pzCopyInnerObjKeys[0].split('_')[1];
                                    } else if (pzCopyInnerObjKeys[1].includes('image')) {
                                        name = objName.replace(pzCopyOuterObjKeys[1], pzCopyInnerObjKeys[1]);
                                        tabAttributeId = pzCopyInnerObjKeys[1].split('_')[1];
                                    }
                                }
                            }

                            if (pzCanvasObject[objName]) {
                                var object = Object.assign({}, {}, pzCanvasObject[objName]);

                                var currPartNames = [];

                                if (object.partNames) {
                                    //partNames = linkModelAttr[0].part_names;
                                    if (object.partNames[0] == "outside") {
                                        currPartNames[0] = "inside";
                                    }
                                }
                                pzCanvasObject[name] = {};
                                pzCanvasObject[name] = Object.assign({}, _extends({}, pzCanvasObject[objName]), { 'partNames': currPartNames });
                                pzCanvasObject[name].name = name;
                                pzCanvasObject[name].tabAttrId = tabAttributeId;
                                pzCanvasObject[name].tabId = pzCopyArraykeys[tabAttributeId]
                                if (!pzCopyObjectsKeys.includes(name)) {
                                    pzCopyObjectsKeys.push(name);
                                }
                            }
                            objectIndex++;
                        });

                        if (pzCopyOuterRepeatObjects.length == objectIndex) {
                            //this.props.HomeComponent.apply2dObjects();
                            apply2dObjects = true;
                            _this.setState({ showCopyPopup: true });
                        }
                    }

                    //}
                    /* else {
                        pzIsCopyRepeatObjects = false;
                        pzShowCopy = false;
                        this.setState({ showCopyPopup: true });
                    } */
                } else if (!pzOptionAttrValue.userEvent && pzOptionAttrValue.attribute_code == "copy_text_logo") {
                    pzIsCopyRepeatObjects = false;
                }
                _this.props.HomeComponent.setState({ pzActiveImages: pzActiveImages, pzActiveOptions: pzActiveOptions, pzProductPrice: pzPrice, pzCanvasObject: pzCanvasObject, pzIsCopyRepeatObjects: pzIsCopyRepeatObjects, pzShowCopy: pzShowCopy, pzCopyObjectsKeys: pzCopyObjectsKeys }, function () {
                    //console.log("pzProductPrice ", pzProductPrice)
                    if (apply2dObjects) {
                        _this.props.HomeComponent.apply2dObjects();
                    }
                    _this.props.HomeComponent.pzApplyRules();
                });
            }
        }, _this.pzHandleReplaceOptions = function (pzReplaceOptions) {
            pzReplaceOptions.map(function (option) {
                _this.pzChangeHandler(undefined, option);
            });
        }, _this.pzChangeHandler = async function (params, pzOptionProperty) {
            var defaultOpt = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
            var e = arguments[3];


            var userEvent = _this.state.showCopyPopup;
            if (e) {
                if (e.target.type == "checkbox") {
                    userEvent = !_this.state.showCopyPopup;
                    _this.setState({ showCopyPopup: !_this.state.showCopyPopup });
                } else {
                    if (e.target.type != "radio") {
                        e.preventDefault();
                    }
                }
            }
            if (params || pzOptionProperty) {
                var _this$props3 = _this.props,
                    pzCanvas = _this$props3.pzCanvas,
                    pzImgUrl = _this$props3.pzImgUrl,
                    pzReplaceImg = _this$props3.pzReplaceImg,
                    pzReplaceModelUrl = _this$props3.pzReplaceModelUrl,
                    pzCanvasObject = _this$props3.pzCanvasObject,
                    pzActiveOptions = _this$props3.pzActiveOptions,
                    pzCustomizer = _this$props3.pzCustomizer,
                    promizeThreeDObj = _this$props3.promizeThreeDObj,
                    pzSceneData = _this$props3.pzSceneData,
                    pzDesktopModels = _this$props3.pzDesktopModels;
                var _this$props4 = _this.props,
                    pzLastVisibleModel = _this$props4.pzLastVisibleModel,
                    pzDownloadedModelUrl = _this$props4.pzDownloadedModelUrl,
                    pzTextGroup = _this$props4.pzTextGroup,
                    pzBaseType = _this$props4.pzBaseType,
                    pzCopyObjectsKeys = _this$props4.pzCopyObjectsKeys,
                    pzPopupAppliedData = _this$props4.pzPopupAppliedData;

                var tabData = _this.props.pzSubTab ? _this.props.pzSubTab : _this.props.pzTab;
                if (!pzOptionProperty) {
                    pzOptionProperty = _extends({}, tabData, params);
                }

                if (e && e.target.type == "checkbox") {
                    pzOptionProperty.checked = e.target.checked;
                }

                if (pzOptionProperty.default_view && pzOptionProperty.default_view != _this.props.pzCurrentView) {
                    pzCurrentView = pzOptionProperty.default_view;
                    _this.props.HomeComponent.setState({ "pzCurrentView": pzOptionProperty.default_view }, function () {
                        _this.props.HomeComponent.pzReloadCanvasObjects();
                    });
                }
                var pzOptionAttrValue = pzOptionProperty.promize_attribute_value;
                pzOptionAttrValue.attribute_code = _this.props.pzAttribute.promize_attribute.attribute_code;
                pzOptionAttrValue.userEvent = userEvent;
                var additionalData = pzOptionProperty.additional_data ? JSON.parse(pzOptionProperty.additional_data) : {};
                var pzAttrValueAdditionalData = pzOptionProperty.promize_attribute_value.additional_data ? JSON.parse(pzOptionProperty.promize_attribute_value.additional_data) : {};
                if (Object.keys(pzAttrValueAdditionalData).length > 0) {
                    pzOptionProperty['bulk_pricing'] = (pzAttrValueAdditionalData.bulk_pricing) ? pzAttrValueAdditionalData.bulk_pricing : 0;
                }

                if (Object.keys(additionalData).length > 0 && additionalData.replaceModel) {
                    var replaceOptions = [];
                    Object.keys(pzActiveOptions).length > 0 && Object.keys(pzActiveOptions).map(function (option) {
                        var tabOptions = pzCustomizer.attributeOptions[pzActiveOptions[option][0]];
                        var optCodeToReplace = pzActiveOptions[option][2] ? pzActiveOptions[option][2].replace(pzBaseType, pzOptionAttrValue.option_value) : null;
                        if (optCodeToReplace && tabOptions) {
                            /* let canvasObj = pzCanvas.getItemByField('tabAttrId', pzActiveOptions[option][0]);
                            if (canvasObj) {
                                pzRemoveObjectFromCanvas(pzCanvas, canvasObj)
                                delete pzCanvasObject[pzCurrentView][canvasObj.name]
                                delete pzActiveOptions[canvasObj.tabAttrId]
                            } */
                            var optionToApply = Object.keys(tabOptions).find(function (key) {
                                return tabOptions[key].promize_attribute_value.option_code === optCodeToReplace;
                            });
                            var optionObj = _extends({}, tabOptions[optionToApply], pzCustomizer.tabs[option]);
                            optionToApply && replaceOptions.push(optionObj);
                        } else if (pzOptionProperty.promize_tab_id != option && tabOptions) {
                            var _optionToApply = Object.keys(tabOptions).find(function (key) {
                                return tabOptions[key].promize_tab_attribute_values_id === parseInt(pzActiveOptions[option][1]);
                            });
                            var _optionObj = _extends({}, tabOptions[_optionToApply], pzCustomizer.tabs[option]);
                            _optionToApply && replaceOptions.push(_optionObj);
                        }
                    });
                    pzBaseType = pzOptionAttrValue.option_value;
                    _this.props.HomeComponent.setState({ pzBaseType: pzOptionAttrValue.option_value }, function () {
                        //console.log("replaceoption", replaceOptions)
                        if (replaceOptions.length > 0) {
                            _this.pzHandleReplaceOptions(replaceOptions);
                        }
                    });
                }
                _this.pzSetActiveOptionHandler(pzOptionProperty.promize_tab_id, pzOptionProperty.promize_tab_attribute_id, pzOptionProperty.promize_tab_attribute_values_id, pzOptionAttrValue, e);
                var pzAttrOptionColorCode = pzOptionAttrValue.option_value && pzOptionAttrValue.option_value.charAt(0) == '#' && _this.pzCheckValidColorCode(pzOptionAttrValue.option_value) ? pzOptionAttrValue.option_value : _this.pzCheckValidColorCode('#' + pzOptionAttrValue.option_value) ? '#' + pzOptionAttrValue.option_value : '';
                var pzObject = '';
                pzOptionProperty['colorCode'] = pzAttrOptionColorCode;
                pzOptionProperty['optionValue'] = pzOptionAttrValue.option_value;

                var pzOptionThumbImg = '';
                if (pzOptionAttrValue.promize_images && Object.keys(pzOptionAttrValue.promize_images).length > 0) {
                    pzOptionThumbImg = pzOptionAttrValue.promize_images.find(function (val) {
                        return val.image_type == "option_thubnail_image";
                    });
                    if (Object.keys(pzOptionThumbImg).length > 0) {
                        pzOptionProperty['thumbImage'] = pzOptionThumbImg['image_url'] ? pzOptionThumbImg['image_url'] : '';
                    }
                }

                //pzPopupAppliedData = { ...this.props.pzPopupAppliedData };
                // console.log("PZ OPTION ==> pzPopupAppliedData ", pzPopupAppliedData)
                var objectImages = {};
                var ObjectType = '';
                if (pzOptionProperty.option_images) {
                    var pzParsedTabAttrImages = pzOptionProperty.option_images ? JSON.parse(pzOptionProperty.option_images) : {};

                    var pzTabAttrImages = _this.pzGetTabAttrOptionImages(pzOptionAttrValue.promize_images, pzParsedTabAttrImages);
                    objectImages = pzTabAttrImages;
                    //console.log("objectImages ", objectImages)

                    ObjectType = 'image';
                    if (pzTabAttrImages && Object.keys(pzTabAttrImages).length == 0 || pzOptionProperty.colorCode) {
                        if (pzOptionProperty.tab_images) {
                            var parsedTabImages = pzOptionProperty.tab_images ? JSON.parse(pzOptionProperty.tab_images) : '';
                            objectImages = parsedTabImages;
                            ObjectType = 'color';
                        }
                    }
                } else if (pzOptionProperty.colorCode) {
                    if (pzOptionProperty.tab_images) {
                        var _parsedTabImages = pzOptionProperty.tab_images ? JSON.parse(pzOptionProperty.tab_images) : '';
                        objectImages = _parsedTabImages;
                        ObjectType = 'color';
                    }
                }
                var apply2dObjectMethodCall = false;
                var outerComponentName = '';
                var linkModelAttr = pzOptionProperty.link_model_attributes ? JSON.parse(pzOptionProperty.link_model_attributes) : '';
                if (linkModelAttr.length > 0) {

                    var modelId = linkModelAttr[0].model_id;
                    var modelUrl = null,
                        partNames = null,
                        componentName = null;
                    if (pzDesktopModels[modelId]) {
                        //modelUrl = pzDesktopModels[modelId].model_url;
                        modelUrl = pzImgUrl.concat(pzDesktopModels[modelId].model_url.replace(pzReplaceModelUrl, '')).concat('?' + Date.now());;
                        partNames = linkModelAttr[0].part_names;
                        componentName = linkModelAttr[0].component_names;
                    }
                    //outerComponentName = componentName[0];
                    /** DELETE tag component */
                    if (componentName && componentName[0] == 'tag_component' && e != undefined && pzOptionProperty.promize_attribute_value.option_code == "") {
                        var tagComponentData = {
                            name: 'tag_component',
                            component: {
                                name: pzBaseType,
                                component: {
                                    name: 'tag'
                                }
                            }
                        };
                        promizeThreeDObj.cleanUpComponent(tagComponentData);
                    }

                    pzOptionProperty['part_names'] = _extends({}, partNames);

                    var modelFCanvasData = {},
                        modelColorData = {},
                        materialData = {},
                        optionImagePartData = {};
                    var canvasPartNamesData = _this.pzGetFabricCanvasData();
                    var imageUrl = null;
                    var addedImageKeysByPartName = {};
                    var textureOptionImg = '';
                    /* let imageUrls = [
                        'https://devcloud.productimize.com/cms/wp-content/themes/salient-child/View360/lanyards_model/tag/textures/silkscreen.png',
                        'https://devcloud.productimize.com/cms/wp-content/themes/salient-child/View360/lanyards_model/tag/textures/dyesub.png'
                    ]
                    */

                    if (Object.keys(objectImages).length > 0) {
                        var pzImages = Object.values(objectImages);
                        var optionImg = pzImgUrl.concat(pzImages[0].replace(pzReplaceImg, '')).concat('?' + Date.now());

                        //console.log("optionImg ", optionImg)

                        if (pzOptionProperty.promize_attribute_value.option_code.includes('silkscreen') || defaultOpt == 1 && componentName && componentName[0] == 'tag_component') {
                            //imageUrl = imageUrls[0]
                            imageUrl = optionImg;
                        } else if (pzOptionProperty.promize_attribute_value.option_code.includes('dyesub')) {
                            imageUrl = optionImg;
                        } else {
                            //const pzImages = Object.values(objectImages);
                            textureOptionImg = optionImg;
                        }
                    }

                    partNames && Object.values(partNames).map(function (partName, idx) {
                        if (imageUrl) {
                            materialData[partName] = {
                                type: 'MeshStandardMaterial',
                                properties: {
                                    color: '',
                                    map: '',
                                    normalMap: imageUrl,
                                    roughness: 0.8,
                                    metalness: 0.01,
                                    roughnessMap: '',
                                    metalnessMap: ''
                                }
                            };
                        }
                        var colorCode = pzAttrOptionColorCode;
                        if (defaultOpt == 1 && componentName && componentName[0] == 'tag_component') {
                            colorCode = colorCode ? colorCode : ''; //'#0f1755'
                        }
                        if (colorCode) {
                            modelColorData[partName] = colorCode;
                        }
                        modelFCanvasData[partName] = {};
                        modelFCanvasData[partName] = _extends({}, canvasPartNamesData);

                        if (Object.keys(objectImages).length > 0 && textureOptionImg) {
                            modelColorData[partName] = '#ffffff';
                            addedImageKeysByPartName[partName] = partName + '_texture';
                            var addOptionImages = {};
                            addOptionImages[partName + '_texture'] = {
                                image: textureOptionImg,
                                properties: {
                                    left: 0,
                                    top: 2048,
                                    scaleX: 1,
                                    scaleY: 1,
                                    applyFullScreen: false,
                                    maxWidth: 2048,
                                    maxHeight: _this.props.pzSizeProperties[pzBaseType].maxHeight,
                                    selectable: false,
                                    lockMovement: true,
                                    evented: false,
                                    layer: 3
                                }
                            };

                            optionImagePartData[partName] = {
                                uploadData: { 'addImage': addOptionImages },
                                /* repeatSettings: {
                                    left: 40,
                                    top: 2048,
                                    objectSpacing: 0,
                                    //spacing: false
                                },
                                uploadobjectSpacing: 1 */
                                repeatSettings: {
                                    spacing: 0,
                                    groupSpacing: 0,
                                    objectSpacing: {}
                                }
                            };
                        }
                    });

                    var modelData = {
                        modelUrl: modelUrl,
                        fitToView: false,
                        position: [0, 0, 0],
                        scale: [170, 170, 170],
                        canvasData: modelFCanvasData
                    };

                    var componentData = {};
                    //console.log("pzBaseType", pzBaseType, "componentName ", componentName)
                    if (pzBaseType == "" && !pzAttrOptionColorCode) {
                        pzBaseType = pzOptionAttrValue.option_value ? pzOptionAttrValue.option_value : '3/4';
                    }

                    //console.log("Comonent DATA pzOptionAttrValue.option_code ", pzOptionAttrValue)

                    var innerComponentData = {};
                    if (componentName && pzBaseType != "" && pzOptionAttrValue.option_code != 'no_breakaway-3/4-3/8-5/8-one') {
                        innerComponentData = {
                            name: componentName && componentName[0] == 'tag_component' ? 'tag' : componentName[0],
                            modelData: modelData,
                            customizationData: {
                                materialData: materialData,
                                colorData: modelColorData ? modelColorData : ''
                            }
                        };
                    } else {
                        innerComponentData = {
                            name: 'empty',
                            modelData: 'empty'
                        };
                    }

                    if (componentName && pzBaseType != "") {
                        componentData = {
                            name: componentName[0],
                            component: {
                                name: componentName == 'tag_component' ? pzBaseType : pzOptionProperty.promize_tab_attribute_values_id,
                                component: innerComponentData
                            }
                        };
                    }
                    //console.log("Comonent DATA **********", componentData)

                    /*  if (pzAttrOptionColorCode) {               
                        modelData['colorData'] = modelColorData;
                     } */
                    if (!textureOptionImg && !pzAttrOptionColorCode && !pzDownloadedModelUrl[modelId] && pzBaseType != "") {

                        /* console.log("componentData ", componentData)
                        let downloadedModelCount = 0
                        if (Object.keys(pzDownloadedModelUrl).length == 0) {
                            downloadedModelCount = 1
                        }
                        pzDownloadedModelUrl[modelId] = {};
                        const model = await promizeThreeDObj.loadModel(modelData); */
                        // promizeThreeDObj.sceneObjects.scene.add(model) 

                        //await promizeThreeDObj.updateComponent(componentData);


                        promizeThreeDObj.updateComponent(componentData).then(function () {

                            if (componentName && componentName[0] != "tag_component" && defaultOpt == 0 && e != undefined) {

                                let padding = 70
                                if (pzOptionAttrValue.option_code.includes('bulldogclip')) padding = 40
                                else if (pzOptionAttrValue.option_code.includes('splitring')) padding = -40
                                else if (pzOptionAttrValue.option_code.includes('snap')) padding = 40
                                else if (pzOptionAttrValue.option_code.includes('swivelhook')) padding = 50
                                else padding = 70

                                var viewData = {
                                    view: {
                                        viewToModel: {
                                            component: {
                                                name: componentName[0],
                                                component: {
                                                    name: componentName[0] == 'tag_component' ? pzBaseType : pzOptionProperty.promize_tab_attribute_values_id,
                                                    component: {
                                                        name: componentName[0] == 'tag_component' ? 'tag' : componentName
                                                    }
                                                }
                                            },
                                            /*cameraPosition: {
                                                x: 34,
                                                y: -48,
                                                z: 42
                                            },
                                            padding: 70*/
                                            cameraPosition: { x: 15, y: -34, z: 5 },
                                            padding: padding
                                        }
                                    }

                                    // console.log("viewData ", viewData)

                                }; promizeThreeDObj.updateView(viewData);
                            } else if (componentName && componentName[0] == "tag_component" && defaultOpt == 0 && e != undefined) {
                                var _viewData = {
                                    view: {
                                        viewToModel: {
                                            component: {
                                                name: componentName[0],
                                                component: {
                                                    name: componentName[0] == 'tag_component' ? pzBaseType : pzOptionProperty.promize_tab_attribute_values_id,
                                                    component: {
                                                        name: componentName[0] == 'tag_component' ? 'tag' : componentName[0]
                                                    }
                                                }
                                            },
                                            cameraPosition: {
                                                x: 117,
                                                y: 18,
                                                z: -6
                                            },
                                            padding: 80
                                        }
                                    }
                                };

                                promizeThreeDObj.updateView(_viewData);
                            }

                            if (pzOptionAttrValue.option_name == 'Sewn' || pzOptionAttrValue.option_name == 'Crimp') {
                                var componentData1 = {
                                    name: 'tag_component',
                                    component: {
                                        name: pzBaseType,
                                        component: {
                                            name: 'tag',
                                            customizationData: {
                                                shapeData: {
                                                    outside: {
                                                        shapeIndex: 0,
                                                        shapeValue: pzOptionAttrValue.option_name == 'Crimp' ? 1 : 0
                                                    },
                                                    inside: {
                                                        shapeIndex: 0,
                                                        shapeValue: pzOptionAttrValue.option_name == 'Crimp' ? 1 : 0
                                                    }
                                                }
                                            }
                                        }
                                    }
                                };
                                promizeThreeDObj.updateComponent(componentData1);
                                //console.log("componen  ", componentData1)
                            }
                        });
                    } else if (!textureOptionImg && pzAttrOptionColorCode && !pzDownloadedModelUrl[modelId] && pzBaseType != "" && componentName && componentName[0] == "breakaway") {

                        //console.log("MODEL ************", componentData)
                        promizeThreeDObj.updateComponent(componentData).then(function () {

                            if (componentName && componentName[0] == "breakaway" && defaultOpt == 0 && e != undefined) {

                                var viewData = {
                                    view: {
                                        viewToModel: {
                                            component: {
                                                name: componentName[0],
                                                component: {
                                                    name: componentName[0] == 'tag_component' ? pzBaseType : pzOptionProperty.promize_tab_attribute_values_id,
                                                    component: {
                                                        name: componentName[0] == 'tag_component' ? 'tag' : componentName[0]
                                                    }
                                                }
                                            },
                                            cameraPosition: {
                                                x: 1,
                                                y: 58,
                                                z: -0.02
                                            },
                                            padding: 60
                                        }
                                    }

                                    //console.log("viewData ", viewData)

                                }; promizeThreeDObj.updateView(viewData);
                            }
                        });
                    } else if (!textureOptionImg && pzAttrOptionColorCode && pzBaseType != "") {
                        //this.props.promizeThreeDObj.cleanUp(['2d-customization-popup-repeat']);
                        //pzPopupAppliedData = {}                    
                        if (Object.keys(pzPopupAppliedData).length > 0 && e != undefined) {

                            //console.log("componentData COLOR Picker  ==> ", e)

                            Object.keys(pzPopupAppliedData).length > 0 && Object.keys(pzCanvasObject).map(function (objKey, objIdx) {
                                if (objKey.includes('background')) {
                                    delete pzCanvasObject[objKey];
                                }
                            });

                            _this.props.promizeThreeDObj.cleanUp(['2d-customization-popup-repeat']);
                            pzPopupAppliedData = {};
                        }

                        //this.pzRemoveImageFromCanvas(partNames, 'texture', '4d-customization-texture-repeat');

                        _this.props.promizeThreeDObj.cleanUp(['4d-customization-texture-repeat']);

                        var componentData = {
                            name: "tag_component",
                            component: {
                                name: pzBaseType ? pzBaseType : '3/4',
                                component: {
                                    name: 'tag',
                                    modelData: modelData,
                                    customizationData: {
                                        colorData: modelColorData
                                    }
                                }
                            }

                            // console.log("componentData COLOR ", componentData)
                        }; promizeThreeDObj.updateComponent(componentData);

                        //promizeThreeDObj.applyColorOrImageToModel(modelColorData, pzDownloadedModelUrl[modelId].materials)
                    } else if (textureOptionImg && Object.keys(optionImagePartData).length > 0) {
                        if (Object.keys(pzPopupAppliedData).length > 0 && e != undefined) {
                            _this.props.promizeThreeDObj.cleanUp(['2d-customization-popup-repeat']);
                            pzPopupAppliedData = {};

                            Object.keys(pzCanvasObject).map(function (objKey, objIdx) {
                                if (objKey.includes('background')) {
                                    delete pzCanvasObject[objKey];
                                }
                            });
                        }
                        //const loadOptionImage = (Object.keys(objectImages).length > 0) ? pzImgUrl.concat(Object.values(objectImages)[0]) : '';
                        pzOptionProperty['src'] = textureOptionImg;
                        pzOptionProperty['sourceOrigin'] = '4d-customization-texture-repeat';
                        pzOptionProperty['uploadedImageKeys'] = _extends({}, addedImageKeysByPartName);

                        var optionImageComponentData = {
                            name: 'tag_component',
                            component: {
                                name: _this.props.pzBaseType ? _this.props.pzBaseType : '3/4',
                                component: {
                                    name: 'tag',
                                    customizationData: {
                                        repeatData: {
                                            //'2d-customization-color-repeat': optionImagePartData
                                            '4d-customization-texture-repeat': optionImagePartData
                                        },
                                        colorData: modelColorData
                                    }
                                }
                            }
                        };
                        if (Object.keys(pzPopupAppliedData).length <= 0) {
                            //console.log("optionImageComponentData TEXTURE  ****", optionImageComponentData)
                            // const customizationData = promizeThreeDObj.getComponentData(optionImageComponentData, 'customizationData');
                            promizeThreeDObj.updateComponent(optionImageComponentData);
                        }
                    }

                    //if ((pzCopyObjectsKeys.length > 0 || (Object.keys(pzPopupAppliedData).length > 0)) && componentName[0] == "tag_component" && e != undefined) {
                    if (_this.props.pzTab.tab_name.toLowerCase() == "width" && componentName[0] == "tag_component" && e != undefined) {
                        //console.log('%c calling apply2dObjects! ', 'background: red; color: white');
                        //setTimeout(() => {
                        //console.log("PZ OPTION ", pzPopupAppliedData)
                        //this.props.HomeComponent.apply2dObjects();
                        //}, 3000)

                        apply2dObjectMethodCall = true;
                    }
                }

                /* Object.keys(pzCanvasObject).length &&
                    Object.keys(pzCanvasObject).map(objectViewId => {
                        const loadOptionImage = (Object.keys(objectImages).length > 0 && objectImages[objectViewId]) ? pzImgUrl.concat(objectImages[objectViewId]) : '';
                        pzOptionProperty['src'] = loadOptionImage;
                        pzObject = pzCreateCanvasObject(objectViewId, ObjectType, pzOptionProperty)
                        if (objectViewId == pzCurrentView && pzOptionProperty['src']) {
                            pzAddObjectToCanvas(pzCanvas, pzObject)
                        } else if (objectViewId == pzCurrentView && ObjectType == 'color') {
                            pzAddObjectToCanvas(pzCanvas, pzObject)
                        }
                        (ObjectType == 'image') ? (pzOptionProperty['src'] ? pzCanvasObject[objectViewId][pzObject.name] = pzObject : '') : pzCanvasObject[objectViewId][pzObject.name] = pzObject;
                        //this.props.HomeComponent.pzUpdateHistoryStack(pzObject);
                    })
                this.props.HomeComponent.setState({ pzCanvasObject }); */

                //console.log("PZ OPTION pzPopupAppliedData ==> ", pzPopupAppliedData)

                //pzOptionProperty['bulk_pricing'] = (pzOptionAttrValue.option_sku) ? pzOptionAttrValue.option_sku : '';
                pzOptionProperty['option_sku'] = pzOptionAttrValue.option_sku ? pzOptionAttrValue.option_sku : '';

                pzObject = _this.props.HomeComponent.pzCreateCartProperties(ObjectType, pzOptionProperty);
                pzCanvasObject[pzObject.name] = pzObject;
                //pzCanvasObject[pzObject.name]['bulk_pricing'] = pzOptionAttrValue.option_sku ? pzOptionAttrValue.option_sku : 0
                _this.props.HomeComponent.setState({ pzCanvasObject: pzCanvasObject, pzLastVisibleModel: pzLastVisibleModel, pzPopupAppliedData: pzPopupAppliedData }, function () {
                    if (apply2dObjectMethodCall) {
                        _this.props.HomeComponent.apply2dObjects();
                    }
                });
            }
        }, _this.pzGetFabricCanvasData = function () {
            var canvasProp = {
                "width": 4096,
                "height": 4096,
                "textCustomization": false,
                "containsClipArt": false,
                "containsUploadImage": true,
                "containsBoundingBox": false,
                "containsMask": false,
                "initObjects": [],
                "uploadImageProperties": {
                    "angle": 180,
                    "left": 2048,
                    "top": 2048,
                    "originX": "center",
                    "originY": "center",
                    "flipX": true,
                    "flipY": true,
                    "borderColor": "white",
                    "borderDashArray": [4, 4],
                    "borderScaleFactor": 1,
                    "borderOpacityWhenMoving": 1,
                    "transparentCorners": false,
                    "lockScalingFlip": true,
                    "maxWidth": 2048,
                    "scaleValue": 1,
                    "minScaleValue": 50,
                    "evented": false,
                    "selectable": false,
                    "applyFullScreen": true
                }
            };
            return canvasProp;
        }, _this.pzGetTabAttrOptionImages = function (attrImages, tabAttrImages) {
            var pzTabAttrOptImages = {};
            if (Object.keys(tabAttrImages).length > 0) {
                Object.keys(tabAttrImages).map(function (optionImageViewId) {
                    if (tabAttrImages[optionImageViewId]) {
                        var image_val = attrImages.find(function (val) {
                            return parseInt(val.promize_images_id) == parseInt(tabAttrImages[optionImageViewId]);
                        });
                        if (image_val) {
                            pzTabAttrOptImages[optionImageViewId] = image_val.image_url;
                        }
                    }
                });
                return pzTabAttrOptImages;
            }
        }, _this.pzOptionColor = function (e, selColor, pzOptionProperty) {
            pzOptionProperty.promize_attribute_value.option_value = selColor;
            _this.pzChangeHandler(pzOptionProperty, undefined, 0, e);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    //quick and dirty BFS children traversal, Im sure you could find a better one


    _createClass(PromizeOption, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            var _this2 = this;

            var _props = this.props,
                pzDefaultOptions = _props.pzDefaultOptions,
                pzOptions = _props.pzOptions,
                pzActiveOptions = _props.pzActiveOptions,
                pzApplyOptions = _props.pzApplyOptions,
                pzCustomizer = _props.pzCustomizer;

            if (pzDefaultOptions.length > 0 && Object.keys(pzActiveOptions).length == 0) {
                var pzOptionArray = Array.from(Object.keys(pzOptions), function (k) {
                    return pzOptions[k];
                });
                var matched = pzDefaultOptions.filter(function (o) {
                    return !pzOptionArray.find(function (o2) {
                        o.promize_tab_attribute_values_id === o2.promize_tab_attribute_values_id;
                    });
                });
                if (matched.length > 0) {
                    matched.map(function (option, index) {
                        var optionObj = _extends({}, option, pzCustomizer.tabs[option.promize_tab_id]);
                        _this2.pzChangeHandler(undefined, optionObj);
                    });
                }
            } else if (pzApplyOptions.length > 0) {
                pzApplyOptions.map(function (opt_id, index) {
                    var matchedOption = pzOptions[opt_id];
                    matchedOption && _this2.pzChangeHandler(matchedOption);
                });
                this.props.HomeComponent.setState({ pzApplyOptions: [] });
            }
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _this3 = this;

            var _props2 = this.props,
                pzDefaultOptions = _props2.pzDefaultOptions,
                pzOptions = _props2.pzOptions,
                pzActiveOptions = _props2.pzActiveOptions,
                pzApplyOptions = _props2.pzApplyOptions,
                pzCustomizer = _props2.pzCustomizer,
                pzTab = _props2.pzTab;

            if (pzDefaultOptions.length > 0 && Object.keys(pzActiveOptions).length == 0) {
                var pzOptionArray = Array.from(Object.keys(pzOptions), function (k) {
                    return pzOptions[k];
                });
                var matched = pzDefaultOptions.filter(function (o) {
                    return !pzOptionArray.find(function (o2) {
                        o.promize_tab_attribute_values_id === o2.promize_tab_attribute_values_id;
                    });
                });
                if (matched.length > 0) {
                    matched.map(function (option, index) {
                        var optionObj = _extends({}, option, pzCustomizer.tabs[option.promize_tab_id]);
                        _this3.pzChangeHandler(undefined, optionObj, 1);
                    });
                }
            } else if (pzApplyOptions.length > 0) {
                //console.log("pZapplyoption", pzApplyOptions)
                pzApplyOptions.map(function (opt_id, index) {
                    var matchedOption = pzOptions[opt_id];
                    _this3.pzChangeHandler(matchedOption);
                });
                this.props.HomeComponent.setState({ pzApplyOptions: [] });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return React.createElement(
                React.Fragment,
                null,
                React.createElement(PZOption, _extends({}, this.props, this.state, { clickHandler: this.pzChangeHandler, mouseHoverHandler: this.pzActiveOptionHoverHandler, pzOptionColor: this.pzOptionColor }))
            );
        }
    }]);

    return PromizeOption;
}(React.Component);